import React from 'react';
import styled from 'styled-components';
import { isLogin } from '../../utils/auth';
import { copyUrl } from '../../utils/url';

interface Props {
  setOpenChatModal: (openModal: boolean) => void;
}

function AIChatModal({ setOpenChatModal }: Props) {
  const handleClose = () => {
    // 비로그인 시에는 항상 노출
    if (!isLogin()) {
      setOpenChatModal(false);
      return;
    }
    localStorage.setItem(
      'chat_modal',
      `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
    );
    setOpenChatModal(false);
  };

  return (
    <Container>
      <Inner>
        <Header>
          <HeaderTitle>
            AI 경공매 찾기
            <span>Beta</span>
          </HeaderTitle>
          <HeaderItemBox>
            <Icon
              src="/assets/images/icon/share-black.svg"
              alt=""
              onClick={() => copyUrl('https://m.zipgoai.com/chat/')}
            />
            <Icon
              src="/assets/images/close/close-black24.svg"
              alt=""
              onClick={handleClose}
            />
          </HeaderItemBox>
        </Header>
        <Content onClick={() => window.open('/chat', '_blank')}>
          <ChatSection>
            <img src="/assets/images/ai-search/ai-chat-icon.svg" alt="" />
            <ChatStartBox>
              <DescriptionBox>
                <DescriptionTitle>
                  어느 지역에서 경공매 매물을 찾으세요?
                </DescriptionTitle>
                <DescriptionGreenText>
                  당신만의 조건을 알려주세요
                </DescriptionGreenText>
              </DescriptionBox>
              <ChatExample>공덕동 초등학교 인근, 아파트</ChatExample>
            </ChatStartBox>
          </ChatSection>
          <ChatInputSeciton>
            <ChatBox>
              <ChatMessage>부동산 경매 물건을 찾아보세요</ChatMessage>
            </ChatBox>
          </ChatInputSeciton>
        </Content>
      </Inner>
    </Container>
  );
}

export default AIChatModal;

const Container = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  justify-content: center;
`;

const Inner = styled.div`
  width: 100%;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: fit-content;
`;

const Header = styled.div`
  width: 100%;
  height: 70px;
  padding: 6px 16px;
  border-bottom: 1px solid #e5e8ea;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;

  span {
    font-size: 14px;
    font-weight: 500;
    color: #6b7280;
  }
`;

const HeaderItemBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const Icon = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

const ChatSection = styled.div`
  width: 100%;
  height: 143px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
`;

const ChatStartBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DescriptionBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DescriptionTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
`;

const DescriptionGreenText = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #16a34a;
`;

const ChatExample = styled.div`
  width: fit-content;
  border-radius: 16px;
  padding: 8px 16px;
  background: #70737c14;

  font-weight: 500;
  font-size: 12px;
`;

const ChatInputSeciton = styled.div`
  padding: 16px;
  border-top: 1px solid #e1e2e4;
`;

const ChatBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 8px;
  border: 1px solid #c084fc;
`;

const ChatMessage = styled.div`
  width: 100%;
  height: 39px;
  padding: 8px 12px;
  font-weight: 500;
  font-size: 16px;
  color: #37383c9c;
`;
